import React from 'react';
import PropTypes from 'prop-types';

const AnalyticsStore = require('../../stores/AnalyticsStore');
import TimeseriesChart from '../chart/TimeseriesChart';
import { ChartTotalsBoxRow, ChartTotalsBox, ChartTotalsBoxItem } from '../chart/ChartTotalsBox';

const propTypes = {
    className: PropTypes.string,
    orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    startDate: PropTypes.object.isRequired,
    endDate: PropTypes.object.isRequired,
    onDateSelect: PropTypes.func
};

const defaultProps = {
    className: '',
    onDateSelect: null
};

class OrgNewStudentStatsChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            analyticsStoreState: AnalyticsStore.getState(),
            getAnalyticsActionId: null
        };

        this.onChartPointSelect = this.onChartPointSelect.bind(this);
        this.unsubscribes = [AnalyticsStore.listen(this.onStoreChange.bind(this, 'analyticsStoreState'))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onStoreChange(storeStateName, state) {
        let additionalState = {};

        if(state.action.id === this.state.getAnalyticsActionId) {
            additionalState.getAnalyticsActionId = null;
        }

        this.setState({ [storeStateName]: state, ...additionalState });
    }

    onChartPointSelect(selectedDate) {
        if (this.props.onDateSelect) {
            this.props.onDateSelect(selectedDate);
        }
    }

    render() {
        const newStudentStats = this.state.analyticsStoreState.newStudentStats[this.props.orgId];
        if (!newStudentStats) {
            return null;
        }

        return (
            <div className={this.props.className}>
                <TimeseriesChart
                    id="new-students-stats-range-chart"
                    height={300}
                    labelShow={false}
                    yInt={true}
                    onPointClick={this.onChartPointSelect}
                    colors={{"Students": "#D62728"}}
                    columns={[newStudentStats.graphData.timeseriesCol, newStudentStats.graphData.studentsCol]}
                />
                <ChartTotalsBoxRow>
                    <ChartTotalsBox title="Totals">
                        <ChartTotalsBoxItem label="New Students" value={newStudentStats.total} />
                    </ChartTotalsBox>
                </ChartTotalsBoxRow>
            </div>
        );
    }
}

OrgNewStudentStatsChart.propTypes = propTypes;
OrgNewStudentStatsChart.defaultProps = defaultProps;

export default OrgNewStudentStatsChart;